import { HTMLAttributes } from 'react';

import Image from 'next/image';

import { imageMetaConverter } from '@lib/server';
import { IconArrowRight } from '@tabler/icons-react';
import { APIImageType } from '@types';
import { clsx } from 'clsx';

import { RichText } from './rich-text';
import { Text } from './text';

export interface MenuCardProps extends HTMLAttributes<HTMLAnchorElement> {
  title: string;
  description: string;
  menuPdf: string;
  featuredImage: APIImageType | Array<APIImageType>;
}

export function MenuCard({ description, menuPdf, title, className, featuredImage, ...rest }: MenuCardProps) {
  const background = imageMetaConverter(featuredImage);

  return (
    <a
      href={menuPdf}
      target="_blank"
      className={clsx(
        'bg-card text-card-foreground border-border group relative z-10 flex min-h-80 max-w-md basis-96 overflow-hidden rounded-sm border shadow-sm',
        className,
      )}
      {...rest}
    >
      <div
        className={clsx(
          featuredImage && 'bg-black/50',
          'z-10 flex w-full flex-col items-center justify-center gap-4 p-10 text-center',
        )}
      >
        <div className="flex flex-col items-center justify-center gap-2">
          <Text element={'h3'}>{title}</Text>
          {description && <RichText>{description}</RichText>}
        </div>
        <Text element={'p'}>
          View Menu <IconArrowRight className="ml-2 inline size-4" />
        </Text>
      </div>

      {background && (
        <Image
          {...background}
          alt={title}
          fill
          className="z-0 object-cover opacity-90 transition group-hover:scale-110 group-hover:opacity-100"
        />
      )}
    </a>
  );
}
